import { useEffect } from "react";

export function PointerEventsFix() {
  useEffect(() => {
    const observer = new MutationObserver(() => {
      const style = document.body.style.pointerEvents;
      if (style === "none") {
        console.warn("Fixing stuck pointer-events on <body>");
        setTimeout(() => {
          document.body.style.pointerEvents = "";
        }, 100);
      }
    });

    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ["style"],
    });

    return () => observer.disconnect();
  }, []);

  return null;
}
